import React, { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const HISTORY_KEYS = [
  { key: 'MedicalHistory', label: 'Medical History', src: 'pmhx' },
  { key: 'SurgicalHistory', label: 'Surgical History', src: 'pshx' },
  { key: 'FamilyHistory', label: 'Family History', src: 'fh' },
  { key: 'SocialHistory', label: 'Social History', src: 'sh' },
]

// 🔒 Helper: detect real content inside HTML
const hasMeaningfulHtml = (html) => {
  if (!html) return false
  const text = html.replace(/<[^>]*>/g, '').trim()
  return text.length > 0
}

const HistoryRecordsFreeType = ({
  patientDBdata,
  patientID,
  setPatientDBdata,
  noteActualId,
}) => {
  const [htmlMap, setHtmlMap] = useState({})

  useEffect(() => {
    const saved =
      patientDBdata?.currentNote?.data?.freeTypesEverything
        ?.historyFreetype || {}

    const histories = patientDBdata?.patientHistories || {}

    const generated = {}
    const updatedHistoryFreetype = { ...saved }
    let shouldUpdate = false

    HISTORY_KEYS.forEach(({ key, src }) => {
      const historyValue = histories?.[src]?.[0]?.[key]

      // 1️⃣ Use saved HTML ONLY if it has real content
      if (hasMeaningfulHtml(saved[key])) {
        generated[key] = saved[key]
        return
      }

      // 2️⃣ Seed editor ONLY if history has value
      if (historyValue) {
        const initialHtml = `
          <div>
            <div>${historyValue}</div>
          </div>
        `
        generated[key] = initialHtml
        updatedHistoryFreetype[key] = initialHtml
        shouldUpdate = true
      }
    })

    setHtmlMap(generated)

    // 3️⃣ Persist ONLY when we actually created something
    if (shouldUpdate) {
      setPatientDBdata((prev) => ({
        ...prev,
        currentNote: {
          ...prev.currentNote,
          data: {
            ...prev.currentNote.data,
            freeTypesEverything: {
              ...prev.currentNote.data?.freeTypesEverything,
              historyFreetype: updatedHistoryFreetype,
            },
          },
        },
      }))
    }
  }, [patientDBdata, patientID])

  const handleBlur = (historyKey) => {
    if (!hasMeaningfulHtml(htmlMap[historyKey])) return

    setPatientDBdata((prev) => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            historyFreetype: {
              ...prev.currentNote.data?.freeTypesEverything?.historyFreetype,
              [historyKey]: htmlMap[historyKey],
            },
          },
        },
      },

      allNotes: prev.allNotes?.map((note) => {
        if (note.id !== noteActualId) return note

        const parsed = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsed,
            freeTypesEverything: {
              ...parsed.freeTypesEverything,
              historyFreetype: {
                ...parsed.freeTypesEverything?.historyFreetype,
                [historyKey]: htmlMap[historyKey],
              },
            },
          }),
        }
      }),
    }))
  }

  const historyItemsToRender = HISTORY_KEYS.filter(({ key }) =>
    hasMeaningfulHtml(htmlMap[key])
  )

  if (historyItemsToRender.length === 0) return null

  return (
    <div className="d-flex flex-column gap-3">
      {historyItemsToRender.map(({ key, label }) => (
        <div key={key} className="d-flex">
          <div style={{ width: '30%' }}>{label}</div>

          <div className="w-100">
            <Editor
              value={htmlMap[key]}
              onChange={(e) =>
                setHtmlMap((prev) => ({
                  ...prev,
                  [key]: e.target.value,
                }))
              }
              onBlur={() => handleBlur(key)}
              containerProps={{
                style: {
                  width: '100%',
                  background: '#2D2D2D',
                  color: 'white',
                  border: 0,
                },
              }}
            >
              <Toolbar hidden />
            </Editor>
          </div>
        </div>
      ))}
    </div>
  )
}

export default HistoryRecordsFreeType
